import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'quotation-type-component', templateUrl: './quotation-type.component.html', styleUrls: ['./quotation-type.component.scss'],
    standalone: false
})
export class BuyerCreateQuotationTypeComponent {
    @Input() isQuotationWithParts: boolean = true;
    @Output() onQuotationTypeChange = new EventEmitter<{isQuotationWithParts: boolean}>();
    @Output() onImportFileClick = new EventEmitter<void>();

    public toggleChangeQuotationType() {
        this.isQuotationWithParts = !this.isQuotationWithParts;
        this.onQuotationTypeChange.emit({ isQuotationWithParts: this.isQuotationWithParts });
    }

    public openImportFile() {
        this.onImportFileClick.emit();
    }
}
